import getScenarioStore from '../selectors/getScenarioStore';
import { mutatorAction } from 'satcheljs';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';

export default mutatorAction(
    'setLatestQFRequestId',
    (latestQFRequestId: string, scenarioId: SearchScenarioId): void => {
        getScenarioStore(scenarioId).latestQFRequestId = latestQFRequestId;
    }
);
